import { Component, OnInit } from '@angular/core';

import { AppContext } from './../../shared';

@Component({
  selector: 'profile-popup',
  template: require('./profile-popup.component.html'),
  styles: [require('./profile-popup.component.scss')],
})
export class ProfilePopupComponent {
  showClose: boolean = false;

  constructor(private app: AppContext) {
  }

  close() {
    this.app.showPersonalInformation = false;
  }

  onSave() {
    this.showClose = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/message/profile-popup/profile-popup.component.ts